import {
    GET_BANNER_LISTING,
    GET_BANNER_LISTING_SUCCESS,
    GET_BANNER_LISTING_FAIL,
    GET_BANNER_DETAILS,
    GET_BANNER_DETAILS_SUCCESS,
    GET_BANNER_DETAILS_FAIL,
    ADD_BANNER,
    ADD_BANNER_SUCCESS,
    ADD_BANNER_FAIL,
    UPDATE_BANNER,
    UPDATE_BANNER_SUCCESS,
    UPDATE_BANNER_FAIL,
    DELETE_BANNER,
    DELETE_BANNER_SUCCESS,
    DELETE_BANNER_FAIL,
    EXPORT_BANNER,
    EXPORT_BANNER_SUCCESS,
    EXPORT_BANNER_FAIL,
    RESET_BANNER_STATE,
    RESET_BANNER_ATTACHMENT_STATE,
} from "./actionTypes";

export const getBannerListing = (banner) => ({
    type: GET_BANNER_LISTING,
    payload: banner,
});

export const getBannerListingSuccess = banner => ({
    type: GET_BANNER_LISTING_SUCCESS,
    payload: banner,
});

export const getBannerListingFail = error => ({
    type: GET_BANNER_LISTING_FAIL,
    payload: error,
});

export const getBannerDetails = bannerId => ({
    type: GET_BANNER_DETAILS,
    payload: bannerId,
});

export const getBannerDetailsSuccess = banner => ({
    type: GET_BANNER_DETAILS_SUCCESS,
    payload: banner,
});

export const getBannerDetailsFail = error => ({
    type: GET_BANNER_DETAILS_FAIL,
    payload: error,
});

export const createBanner = banner => ({
    type: ADD_BANNER,
    payload: banner,
});

export const createBannerSuccess = banner => ({
    type: ADD_BANNER_SUCCESS,
    payload: banner,
});

export const createBannerFail = error => ({
    type: ADD_BANNER_FAIL,
    payload: error,
});

export const updateBanner = banner => ({
    type: UPDATE_BANNER,
    payload: banner,
});

export const updateBannerSuccess = banner => ({
    type: UPDATE_BANNER_SUCCESS,
    payload: banner,
});

export const updateBannerFail = error => ({
    type: UPDATE_BANNER_FAIL,
    payload: error,
});

export const deleteBanner = bannerId => ({
    type: DELETE_BANNER,
    payload: bannerId,
});

export const deleteBannerSuccess = bannerId => ({
    type: DELETE_BANNER_SUCCESS,
    payload: bannerId,
});

export const deleteBannerFail = error => ({
    type: DELETE_BANNER_FAIL,
    payload: error,
});

export const exportBanner = data => ({
    type: EXPORT_BANNER,
    payload: data,
});

export const exportBannerSuccess = data => ({
    type: EXPORT_BANNER_SUCCESS,
    payload: data,
});

export const exportBannerFail = error => ({
    type: EXPORT_BANNER_FAIL,
    payload: error,
});

//reset
export const resetBannerAttachmentState = () => {
    return {
        type: RESET_BANNER_ATTACHMENT_STATE,
    }
}
export const resetBannerState = () => {
    return {
        type: RESET_BANNER_STATE,
    }
}

